import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
  Input,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledAlert,
  ModalHeader,
  Modal,
  UncontrolledTooltip,
  Button
} from "reactstrap";
import classnames from "classnames";
import ToastDialog from "components/Common/ToastDialog";
import Loader from "react-spinner-loader";
import CommonDialog from "components/Common/CommonDialog";
import "./style.scss";

import tradeIcon from '../../assets/icons/Group 1707478291.svg';
import payearlyIcon from '../../assets/icons/Group 1707478292.svg';
import disabledTradeIcon from '../../assets/icons/Group 1707478293.svg';
import disabledPayearlyIcon from '../../assets/icons/Group 1707478294.svg'
import financierIconGray from '../../assets/icons/image 2569 (traced) gray.svg'
import financierIcon from '../../assets/icons/image 2569 (traced).svg'
//Import Breadcrumb
import { isPermission, uId, dateFormat, decryptedValue } from "common/utility";
import { downloadCamProfile, downloadCamProfileWord, getEntityWiseDeal, getOneDeal } from "http/fundLync/deal.helper";
import {
  getAddress,
  getAuthorisedPersonList,
  getEntityInformation,
  getMeetingByEntity,
  getNotesTableData,
  getOneEntity,
  getTaskByEntity,
  checkEntityDetails,
  pushToTradeasyPayearly,
  pushToTradeasy,
  pushToPayearly,
} from "http/fundLync/entityAndAddress.helper";
import EntityMeetingTable from "./entityMeetings";
import ScheduleMeetngForm from "pages/Meetings/scheduleMeeting";
import EntityNotesTable from "./entityNotes";
import EntityTaskTable from "./entityTasks";
import AddTaskForm from "pages/Tasks/addTask";
import EditEntityNote from "./updateEntityNotes";
import AddEntityNotes from "./addNotes"
import UpdateEntityMeetings from "./updateEntityMeeting";
import ViewEntityMeetingDetails from "./ViewEntityMeetingDetails";
import UpdateEntityTask from "./updateEntityTask";
import ViewEntityTaskDetails from "./viewEntityTask";




import UpdateEntity from "./entityDetails";
import Proprietors from "./proprietor";
import Partners from "./partners";
import ShareholdingPatterns from "./shareholdingPattern";
import BorrowingProfile, { formatDateString1 } from "./borrowingProfile";
import Directors from "./directors";
import CreditVerification from "./CreditVerification";
import ITRDocuments from "./itrDocuments";
import GSTDocuments from "./gstDocuments";
import FinancialDocuments from "./financialDocument";
import AdditionalDocuments from "./additionalDocuments";
import BSADocuments from "./bsaDocuments";
import { getPrimaryPoc } from "http/fundLync/poc.helper";
import axios from "axios";
import { callGetFinancialsSummary, callGetProbeCreditRatings, callGetProveBaseApi, callProbeBAseApi } from "http/fundLync/entityDocuments.helper";
import { isEmpty } from "lodash";
import EntityDataTable from "pages/EntityMoreInformation/EntityDataTable";
import EntityMoreInformation from "pages/EntityMoreInformation";
import EntityInformation from "pages/EntityInformation/information";
import { downloadSystemConfigFile, getOneSystemConfiguration } from "http/UAM/systemConfig.helper";
import Provisional from "./provisional";
import { getCamData } from "http/fundLync/cam.helper";


const EntityDashboard = (props) => {
  //meta title
  document.title = "Dashboard | FundLync";
  const navigate = useNavigate();
  const [entityId, setEntityId] = useState();
  const [constituition, setConstituition] = useState();
  const [entityDetail, setEntityDetail] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [isApprovePermission, setIsApprovePermission] = useState(false);
  const [isNewDealPermission, setIsNewDealPermission] = useState(false)
  const [totalMeeting, setTotalMeetings] = useState([]);
  const [totalTask, setTotalTask] = useState([]);
  const [totalNotes, setTotalNotes] = useState([]);
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [entityProfileTab, setEntityProfileTab] = useState('7');
  const [documentTab, setDocumentTab] = useState('13');
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [isViewFormVisible, setIsViewFormVisible] = useState(false);
  const [isTaskTableVisible, setIsTaskTableVisible] = useState(true);
  const [isTaskFormVisible, setIsTaskFormVisible] = useState(false);
  const [isEditTaskVisible, setIsEditTaskVisible] = useState(false);
  const [isViewTaskVisible, setIsViewTaskVisible] = useState(false);
  const [isNotesTableVisible, setIsNotesTableVisible] = useState(true);
  const [isNotesFormVisible, setIsNotesFormVisible] = useState(false);
  const [isEditNotesVisible, setIsEditNoteVisible] = useState(false);
  const [editMeetingId, setEditMeetingId] = useState(null);
  const [viewMeetingId, setViewMeetingId] = useState(null);

  const [editNoteId, setEditNoteId] = useState(null);
  const [editTaskId, setEditTaskId] = useState(null);
  const [viewTaskId, setViewTaskId] = useState(null);
  const [checkEntityFinancialsDetails, setCheckEntityFinancialsDetails] = useState(false);

  const [pushToTradeasyPayearlyPemission, setPushToTraeasyPayearly] = useState(false);
  const [showCommonDialog, setShowCommonDialog] = useState({isShow:false});
  const [authorisedPersonList, setAuthorisedPersonList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isTradeasyFlag, setIsTradeasyFlag] = useState(false);
  const [isPayEarlyFlag, setIsPayEarlyFlag] = useState(false);
  const [loaderPayEarly, setLoaderPayEarly] = useState(false);
  const [responseId, setResponseId]=useState([]);
  const [addressList, setAddressList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [entity, setEntity] = useState([]);
  const [refererType, setRefererType] = useState('');
  const [pocList, setPocList] = useState([]);
  const [isPanExists, setIsPanExists] = useState(false)
  const [financialSummary, setFinancialSummary] = useState([]); 
  const [isDropdownOpen, setDropdownOpen] = useState([true, false, false]);
  const [isDropdownOpenNew, setDropdownOpenNew] = useState([true, false, false]);
  const [iconStatus, setIconStatus] = useState(false);
  const [entityData, setEntityData] = useState([]);
  const [columns1, setColumns] = useState([]);
  const [columnsCAM, setColumnsCAM] =useState([])
  const [data1, setData] = useState([]);
  const [dataCAM, setDataCAM] = useState([]);

  const [showDealModal, setShowDealModal] = useState(false); 
  const [selectedDealId, setSelectedDealId] = useState(""); 
const [dealDetails, setDealDetails] = useState('');
const [content, setContent] = useState("");
const [errorMessage, setErrorMessage] = useState('');
const [isPDF, setPDF] = useState(false)
const [isCamGeneration, setIsCamGeneration] = useState(false)
const [isFetchingData, setIsFetchingData] = useState(true);
const editor = useRef(null);
  const toggleDropdown = (index) => {
    setDropdownOpen((prevState) =>
      prevState.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );
  };
  const toggleDropdownNew = (index) => {
    setDropdownOpenNew((prevState) =>
      prevState.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );
  };
  const entityDetails =decryptedValue(localStorage.getItem("user"));
  // const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");

  useEffect(() => {
    checkPermissions();
    const urlParams = new URLSearchParams(window.location.search);
    const encodedId = urlParams.get("id");
    if (encodedId) {
      setEntityId(atob(encodedId));
    } else {
      const entityDetails = decryptedValue(localStorage.getItem("user"));
     
      setEntityId(entityDetails.entityId);
      
    }
  }, []);
  useEffect(() => {
    if (constituition === "Public Limited Company" || constituition === "Private Limited Company") {
      setDocumentTab('13');
    } else {
      setDocumentTab('13');
    }
  }, [constituition]);
  useEffect(() => {
    const entity = entityDetail[0];
    if (!entity) return;
    setConstituition(entity.entityConstitution);
  }, [entityDetail]);

  const user = decryptedValue(localStorage.getItem("user"));

  const fetchMeetings = async (id) => {
    try {
      const response = await getMeetingByEntity({ entityId: id });
      if (response.code == 200 && response.status) {
        setTotalMeetings(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchNotes = async (id) => {
    try {
      const response = await getNotesTableData({ entityId: id, user });
      if (response.code == 200 && response.status && response.data.data) {
        setTotalNotes(response.data.data);
      }
      else {
        setTotalNotes([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTasks = async (id) => {
    try {
      const response = await getTaskByEntity({ entityId: id });
      if (response.code == 200 && response.status) {
        setTotalTask(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!entityId) return;
    getOneEntity({ entityId })
      .then((response) => {
        if (response) {
          setEntityDetail(response.data);
          if(response.data[0]?.pan){ 
            setIsPanExists(true)
          }
          else{
            setIsPanExists(false)
          } 
        }
      })
      .catch((error) => {
        console.error(error);
      });
    getPrimaryPoc({ entityId })
      .then((response) => {
        if (response.status) {
            setPocList(response?.data);
        }
        else{
            setPocList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    getEntityWiseDeal({ entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setDealList(response.data.rows);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    checkEntityDetails({ entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          if(response?.data){
            setCheckEntityFinancialsDetails(true)
          }else{
            setCheckEntityFinancialsDetails(false)
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // fetchMeetings(entityId);
    // fetchNotes(entityId);
    // fetchTasks(entityId);
    loadData(entityId)
  }, [entityId]);

  const loadData = async () => {
    try {
      const entityResponse = await getOneEntity({ entityId });
      let entityData = entityResponse.data;
      setIsTradeasyFlag(!!entityData[0].tradeasyId);
      setIsPayEarlyFlag(!!entityData[0].payearlyId);
      const entityAddresses = await getAddress({ entityId });
      const authType = getAuthType(entityData[0].entityConstitution);
      const authorisedPersons = await getAuthorisedPersonList({entityId , type :authType})
      setEntity(entityData[0])
      setAddressList(entityAddresses.data?.data || [])
      setAuthorisedPersonList(authorisedPersons.data?.data || [])

    } catch (error) {
      console.log(error)
    }
  };
  const getAuthType = (constitution) => {
    switch (constitution) {
      case 'Private Limited Company':
      case 'Public Limited Company':
        return 'director';
      case 'Limited Liability Partnership':
      case 'Partnership':
        return 'partner';
      case 'Proprietorship':
        return 'proprietor';
      default:
        return '';
    }
  };
  const checkPermissions = async () => {
    const isAddNew = await isPermission("approve_deal", "approve_permission");
    const isNewDealpermission = await isPermission("deal_detail", "create_permission")
    const pushToTradeasyPayearly = await isPermission(
      "push_to_tradeasy_payearly",
      "create_permission"
      
    )
    const iscamGeneration = await isPermission("cam_generation", "create_permission");
    setIsCamGeneration(iscamGeneration)
    setPushToTraeasyPayearly(pushToTradeasyPayearly);
    setIsNewDealPermission(isNewDealpermission)
    setIsApprovePermission(isAddNew);
  };


  const navigateToAddDeal = () => {
    const encryptedId = btoa(entityId.toString());
    const nonFinancierType = btoa(entityDetail[0]?.nonFinancierType?.toString());
    const entityName = btoa(entityDetail[0]?.entityName?.toString());
    let url = `/${entityDetails.roleName}/addDeal?id=${encodeURIComponent(encryptedId)}&nonFinancierType=${encodeURIComponent(nonFinancierType)}&entityName=${encodeURIComponent(entityName)}`;
    if (entityDetails.entityType == 'Customer') {
      navigate(`/customer/createDeal?id=${encodeURIComponent(encryptedId)}&nonFinancierType=${encodeURIComponent(nonFinancierType)}&entityName=${encodeURIComponent(entityName)}`);
    }else{
      navigate(url);
    }
  };

  const navigateToEditDeal = (id) => {
    const encryptedId = btoa(id.toString());
    if (entityDetails.entityType == "Owner" || entityDetails.entityType == "Partner") {
      navigate(`/${entityDetails.roleName}/editDeal?id=${encryptedId}`);
    } else {
      navigate(`/customer/editDeal?id=${encryptedId}`);
    }
  };

  const navigateToViewDeal = (id) => {
    const encryptedId = btoa(id.toString());
    if (entityDetails.entityType == "Owner" || entityDetails.entityType == "Partner") {
      navigate(`/${entityDetails.roleName}/viewDeal?id=${encryptedId}`);
    } else {
      navigate(`/customer/viewDeal?id=${encryptedId}`);
    }
  };
  const fetchData = async (encryptedDealId) => {
    setIsFetchingData(true);
    try {
      const response = await getCamData({ dealId: encryptedDealId });
      return response.data[0]?.lastVisitedStep;
    } catch (error) {
      console.error("Error fetching CAM data:", error);
      return null;
    } finally {
      setIsFetchingData(false);
    }
  };

  const navigateToCamGenerate = async (id) => {
    const encrypteddealId = btoa(id.toString());
    const encodedId = btoa(entityDetail[0].id.toString());
    const encryptedId = btoa(entityId.toString());
    const decodedDealIds = atob(encrypteddealId);
    const lastVisitedStep = await fetchData(decodedDealIds);
    if (lastVisitedStep !== null) {
      if (entityDetails.entityType === "Owner" || entityDetails.entityType === "Partner") {
        navigate(`/${entityDetails.roleName}/entity/cam-generation?dealId=${encrypteddealId}&id=${encryptedId || ""}&step=${lastVisitedStep || ""}`);
      } else {
        navigate(`/customer/entity/cam-generationt?dealId=${encrypteddealId}&id=${encryptedId || ""}`);
      }
    } else {
      if (entityDetails.entityType === "Owner" || entityDetails.entityType === "Partner") {
        navigate(`/${entityDetails.roleName}/entity/cam-generation?dealId=${encrypteddealId}&id=${encryptedId || ""}`);
      } else {
        navigate(`/customer/entity/cam-generation?dealId=${encrypteddealId}&id=${encryptedId || ""}`);
      }
    }
  };

  const navigateToScheduleMeeting = () => {
    const encryptedId = btoa(entityId.toString());
    let url = `/${entityDetails.roleName}/schedule-meeting?id=${encryptedId}&entityName=${entityDetail[0].entityName || ""}`;
    navigate(url);
  };

  const navigateToAddTask = () => {
    const encryptedId = btoa(entityId.toString());
    let url = `/${entityDetails.roleName}/add-task?id=${encryptedId}&entityName=${entityDetail[0].entityName || ""}`;
    navigate(url);
  };

  const navigateToAddNotes = () => {
    const encryptedId = btoa(entityId.toString());
    navigate(`/${entityDetails.roleName}/entity/add-notes?id=${encryptedId}&entityName=${entityDetail[0].entityName || ""}`);
  };

  const handleRedirect = (id, query) => {
    const encrypteddealId = btoa(id.toString());
    navigate(`/${entityDetails.roleName}/entity/deal-fin?dealId=${encrypteddealId}&query=${query}`);
  };

  const handleDealSelection = (e) => {
    const dealId = e.target.value;
    setErrorMessage('');
    setSelectedDealId(dealId);

    getOneDeal({ id: dealId })
      .then((response) => {
        if (response) {
          setDealDetails(response);
        }
      })
      .catch((error) => {
        console.error("Error fetching deal details:", error);
      });
  };

  let columnsProfile = []
  let dataProfile = []
  const transformData1 = (apiData) => {
    if (!isEmpty(apiData) && Array.isArray(apiData)) {
      let newColumns = []
      let tempCol = apiData.map((dataItem, index) => {
        let year = dataItem.filter((item) => {
          return item.key === 'year';
        });
        let yearValue = year[0].value
        return dateFormat(yearValue, "YYYY")
      })

      newColumns = [...newColumns, {
        name: 'Particulars (Amount Lac.)',
        selector: 'title',
        key: 'title',
        sortable: true,
      }]
      let tempColumns = tempCol.map((item, index) => {
        return {
          name: item,
          selector: item,
          key: item,
          sortable: true,
        }
      })
      columnsProfile = [...newColumns, ...tempColumns]
      setColumnsCAM(columnsProfile)
    }

    let tempData = {}
    const transformedData = {};

    apiData.forEach((row, index) => {
      row.forEach(item => {
        if (item.key === "year") return;
        if (!transformedData[item.displayName]) {
          transformedData[item.displayName] = {};
        }
        transformedData[item.displayName][columnsProfile[index + 1]['key']] = item.value;
      });
    });

    const finalData = Object.keys(transformedData).map(title => ({
      title,
      ...transformedData[title],
    }));

    tempData = {
      dataProfile: finalData
    }

    dataProfile = [...data, tempData]
    setDataCAM(dataProfile)
  }

  const navigateToentityProfile = (dealId = "") => {
    const encryptedId = btoa(entityId.toString());
    const encryptedDealId = btoa(dealId.toString());
    let url
    if(dealId != "") {
      url = `/${entityDetails.roleName}/entity/entity-profile?id=${encodeURIComponent(
      encryptedId
      )}&entityName=${entityDetail[0]?.entityName || ""}&dealId=${encryptedDealId}&location=${entityDetail[0]?.addresses[0]?.city || ""}`;
    }else{
      url = `/${entityDetails.roleName}/entity/entity-profile?id=${encodeURIComponent(
        encryptedId
        )}&entityName=${entityDetail[0]?.entityName || ""}&location=${entityDetail[0]?.addresses[0]?.city || ""}`;
    }
    
    navigate(url);
  };

  const formatNumberWithCommas = (number) => {
    const formattedNumber = number.toString().replace(/\./, ',');
    const parts = formattedNumber.split(',');
    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    return parts.join(',');
  };

  const truncateText = (text, charLimit) => {
    if (text && text.length > charLimit) {
      const truncated = text.substring(0, charLimit) + '...';
      return truncated;
    }
    return text;
  };
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
      if (tab === "7") {
        if (!financialSummary) {
          fetchFinancialSummary(entityId);
        }
      }
    }
  };
  const toggleEntityProfile = (tab) => {
    if (entityProfileTab !== tab) setEntityProfileTab(tab);
  };
  const toggleDocumentTab = (tab) => {
    if (documentTab !== tab) setDocumentTab(tab);
  };

  //Meeting Controllers

  //Meeting Schedule Controller
  const handleCreateNewMeeting = () => {
    setIsFormVisible(true);
    setIsTableVisible(false);
    
  };

  const handleScheduleMeeting = () => {
    setIsFormVisible(false);
    setIsTableVisible(true);
    fetchMeetings(entityId);
  };

  const handleCancelMeeting = () => {
    setIsFormVisible(false);
    setIsTableVisible(true);
  };

  //Meeting Update Controller
  const handleEditMeeting = (id) => {
    setEditMeetingId(id);
    setIsEditFormVisible(true);
    setIsTableVisible(false);
    setIsFormVisible(false);

  };

  const handleUpdateMeetingButton = () => {
    setIsEditFormVisible(false);
    setIsTableVisible(true);
  };

  const handleCancelMeetingButton = () => {
    setIsEditFormVisible(false);
    setIsTableVisible(true);
  };

  //View meeting Controller
  const handleviewMeeting = (id) => {
    setViewMeetingId(id);
    setIsViewFormVisible(true);
    setIsTableVisible(false);
    setIsFormVisible(false);
  };

  const handleCancelViewButton = () => {
    setIsViewFormVisible(false);
    setIsTableVisible(true);
  };

  //Task Controllers

  const handleCreateNewTaskButton = () => {
    setIsTaskFormVisible(true);
    setIsTaskTableVisible(false);
  };

  const handleCreateNewtask = () => {
    setIsTaskFormVisible(false);
    setIsTaskTableVisible(true);
    fetchTasks(entityId);
  };

  const handleCancelTask = () => {
    setIsTaskFormVisible(false);
    setIsTaskTableVisible(true);
  };

  //Task Update Controller
  const handleEditTask = (id) => {
    setEditTaskId(id);
    setIsEditTaskVisible(true);
    setIsTaskTableVisible(false);
    setIsTaskFormVisible(false);
  };

  const handleUpdateTaskButton = () => {
    setIsTaskFormVisible(false);
    setIsTaskTableVisible(true);
  };

  const handleCancelTaskButton = () => {
    setIsEditTaskVisible(false);
    setIsTaskTableVisible(true);
  };

  //View meeting Controller
  const handleviewTask = (id) => {
    setViewTaskId(id);
    setIsViewTaskVisible(true);
    setIsTaskFormVisible(false);
    setIsTaskTableVisible(false);

  };

  const handleCancelTaskViewButton = () => {
    setIsViewTaskVisible(false);
    setIsTaskTableVisible(true);
  };


  //Notes Controller


  const handleCreateNewNoteButton = () => {
    setIsNotesFormVisible(true);
    setIsNotesTableVisible(false);
  };

  const handleCreateNewNote = () => {
    setIsNotesFormVisible(false);
    setIsNotesTableVisible(true);
    fetchNotes(entityId);
  };

  const handleCancelNote = () => {
    setIsNotesFormVisible(false);
    setIsNotesTableVisible(true);
  };

  //Notes Update Controller
  const handleEditNote = (id) => {
    setEditNoteId(id);
    setIsEditNoteVisible(true);
    setIsNotesTableVisible(false);
    setIsNotesFormVisible(false);
  };

  const handleUpdateNoteButton = () => {
    setIsEditNoteVisible(false);
    setIsNotesTableVisible(true);
  };

  const handleCancelNoteButton = () => {
    setIsEditNoteVisible(false);
    setIsNotesTableVisible(true);
  };



  useEffect(() => {
    if (customActiveTab !== '4' || customActiveTab !== '5' || customActiveTab !== '6') {
      setIsTableVisible(true);
      setIsFormVisible(false);
      setIsViewFormVisible(false);
      setIsEditFormVisible(false);

      setIsNotesTableVisible(true);
      setIsEditNoteVisible(false);
      setIsNotesFormVisible(false);


      setIsTaskTableVisible(true);
      setIsTaskFormVisible(false);
      setIsViewTaskVisible(false);
      setIsEditTaskVisible(false);
    }
  }, [customActiveTab]);

  const getDisplayName = (user) => {
    const firstName = user?.first_name ? toSentenceCase(user.first_name) : '';
    const lastName = user?.last_name ? toSentenceCase(user.last_name) : '';
    if (firstName || lastName) {
      return `${firstName || ''} ${lastName || ''}`.trim();
    } else {
      return '';
    }
  };
  const getDisplayNamePOC = (user) => {
    const firstName = user?.firstname ? toSentenceCase(user.firstname) : '';
    const lastName = user?.lastname ? toSentenceCase(user.lastname) : '';
    if (firstName || lastName) {
      return `${firstName || ''} ${lastName || ''}`.trim();
    } else {
      return '';
    }
  };

  const toSentenceCase = (str) => {
    if (!str || str === undefined ) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const productNameArray = (products)=>{
    if(products){
      let productArray = products.split(', ')
      return productArray
    }else{
      return []
    }
  }
  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost')) {
      setRefererType('local');
    }else if (hostname.includes('fundlyncuat')) {
      setRefererType('uat');
    } else if (hostname.includes('fundlync')) {
      setRefererType('prod');
    }
  }, []);

  const handleSubmitTradeasy = async () => {
    const user = decryptedValue(localStorage.getItem("user"));
    const data = {
      ...entity,
      address: addressList,
      authorisedPerson: authorisedPersonList,
      // users: userList,
      created_by_entity_type : "fundlync",
      created_by_email: user.email,
      created_by:user.email,
      refererType: refererType
    };
    pushToTradeasy(data)
      .then((response) => {
        if (response.data.ED.result.success && response.code === 200) {
          setLoader(false);
          const data = {
            tradeasyId: response.data.ED.data.tradeasy_id,
            id: entityId
          };
          pushToTradeasyPayearly(data)
          getOneEntity({ entityId })
           .then((response) => {
              let entityData = response.data;
              setEntity(entityData[0])
            })
            .catch((error) => {
            });
          setToastInfo({
            message: "Entity Succefully added in tradeEasy",
            showToast: true,
            role: "success",
          });
          setIsTradeasyFlag(true)
        }else if(response.data.ED.result.message === "Entity Pan already exists"){
          setLoaderPayEarly(false);
          const data = {
            tradeasyId: response.data.ED.data.tradeasy_id,
            id: entityId
          };
          pushToTradeasyPayearly(data)
          getOneEntity({ entityId })
           .then((response) => {
              let entityData = response.data;
              setEntity(entityData[0])
            })
            .catch((error) => {
            });
          setToastInfo({
            message: "Entity Already exist in tradeEasy",
            showToast: true,
            role: "success",
          });
          setIsTradeasyFlag(true)
        } else {
          setToastInfo({
            message: "Access Denied",
            showToast: true,
            role: "error",
          });
          
        }
      })
      .catch((error) => {
        setLoaderPayEarly(false)
        setToastInfo({
          message: "Something Went Wrong",
          showToast: true,
          role: "error",
        });
      });
  };
  const handleSubmitPayEarly = async () => {
    const user = decryptedValue(localStorage.getItem("user"));
    const data = {
      ...entity,
      address: addressList,
      authorisedPerson: authorisedPersonList,
      // users: userList,
      created_by_entity_type : "fundlync",
      created_by_email: user.email,
      created_by:user.email,
      refererType: refererType
    };
    if(data.gstnIn !== "" && data.gstnIn !== null){
      pushToPayearly(data)
      .then((response) => {
        if (response.data.ED.result.success && response.code === 200) {
          setLoaderPayEarly(false);
          const data = {
            payearlyId: response.data.ED.data.tradeasy_id,
            id: entityId
          };
          pushToTradeasyPayearly(data)
          getOneEntity({ entityId })
           .then((response) => {
              let entityData = response.data;
              setEntity(entityData[0])
            })
            .catch((error) => {
            });
          setToastInfo({
            message: "Entity Succefully added in PayEarly",
            showToast: true,
            role: "success",
          });
          setIsPayEarlyFlag(true)
        }else if(response.data.ED.result.message === "Entity GSTN already exists" || response.data.ED.result.message === "Entity Pan already exists"){
          setLoaderPayEarly(false);
          const data = {
            payearlyId: response.data.ED.data.payearly_id,
            id: entityId
          };
          pushToTradeasyPayearly(data)
          
          getOneEntity({ entityId })
           .then((response) => {
              let entityData = response.data;
              setEntity(entityData[0])
            })
            .catch((error) => {
            });
          setToastInfo({
            message: "Entity Already exist in tradeEasy",
            showToast: true,
            role: "success",
          });
          setIsPayEarlyFlag(true)
        }
         else {
          setToastInfo({
            message: "Access Denied",
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error) => {
        setLoaderPayEarly(false);
        setToastInfo({
          message: "Something Went Wrong",
          showToast: true,
          role: "error",
        });
      });
    }else{
      setToastInfo({
        message: "Please fill in GSTIN for entity",
        showToast: true,
        role: "error",
      });
    }
    
  };
 
  const handleSubmitInfo = async () => {
    setLoading(true);
    const postParams = {
      entity_id: entityId,
    };

    callProbeBAseApi(postParams)
      .then((response) => {
        setLoading(false);
        if (response.code == 200 && response.status) {
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "success",
          });
          setIconStatus(true);

          fetchFinancialSummary(entityId)
            .then((financialSummaryResponse) => {
              const respondedAt = financialSummaryResponse?.respondedAt;
            })
            .catch((error) => {
              console.error("Error fetching financial summary:", error);
            });
        } else {
          setToastInfo({
            message: response.message || "Failed to fetch data",
            showToast: true,
            role: "error",
          });
          setIconStatus(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setToastInfo({
          message: error.message || "Something went wrong",
          showToast: true,
          role: "error",
        });
        setIconStatus(false);
      });
  };
  
  
  
  const dialogAction = (action, data) => {
    if (action == 1 && data.type == "tradeEasy") {
      setShowCommonDialog({ isShow: false })
      handleSubmitTradeasy()
    } else if (action == 1 && data.type == "payearly"){
      setShowCommonDialog({ isShow: false })
      handleSubmitPayEarly()
    }else if (action == 1 && data.type == "icon"){
      setShowCommonDialog({ isShow: false })
      handleSubmitInfo();
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }
  const buttonStyle = (flag) => ({
    padding: "5px",
    margin: "5px",
    fontWeight: 600,
    border: "none",
    backgroundColor: "white",
    cursor: 'pointer'
  });


  const handleTradeEasyClick = () => {
    if (!isTradeasyFlag) {
      const message = 'Are you sure you want to push this entity to TradeEasy?';
      setShowCommonDialog({ isShow: true, message: message, data: { type: 'tradeEasy' } });
    } else {
      navigateToTradeEasyPage();
    }
  };

  const handlePayearlyClick = () => {
    if (!isPayEarlyFlag) {
      const message =
        "Are you sure want to push this entity to PayEarly?";
      setShowCommonDialog({
        isShow: true,
        message: message,
        data: { type: "payearly" },
      });
    } else {
      navigateToPayearly();
    }
  };

  const navigateToTradeEasyPage = async() => {
    const response = await getOneEntity({entityId})
    const encryptedId1 = btoa(response.data[0]?.tradeasyId.toString());
    const url = await getOneSystemConfiguration({ configKey: 'TRADEASY_REDIRECT_LINK' })
    window.location.href = `${url.data[0]?.configValue}&id=${encryptedId1}`;
  };

  const navigateToPayearly = async() => {
    const response = await getOneEntity({entityId})
    const encryptedId1 = btoa(response.data[0]?.payearlyId.toString());
    const url = await getOneSystemConfiguration({ configKey: 'PAYEARLY_REDIRECT_LINK' })
    window.location.href = `${url.data[0]?.configValue}&id=${encryptedId1}`;
  };

  const fetchFinancialSummary = async (entityId) => {
    try {
      const bodyData = { entityId};
      const response = await callGetProveBaseApi(bodyData);

      const respondedAt = response?.data?.respondedAt;

      if (response.data.isDataFetched) {
        setIconStatus(true);
        return { ...response.data, respondedAt };
      } else {
        setIconStatus(false);
        return { isDataFetched: false };
      }
    } catch (error) {
      setIconStatus(false);
    }
  };
  
  useEffect(() => {
    if (customActiveTab == 7) {
      getEntityData();
    }
  }, [ customActiveTab,]);
  
  const getEntityData = async () => {
    setEntityData([]);
    setData([]); 
    const bodyData = {
      entityId: entityId
    };

    const entityInfo = await callGetFinancialsSummary(bodyData);
    if (entityInfo.code === 200 && entityInfo.status) {
      const flattenedData = entityInfo.data.flat();
      const firstId = flattenedData.length > 0 ? flattenedData[0].responseId : null;
      setResponseId(firstId)
  }
    if (entityInfo.status) {
      setEntityData({
        key: "FInInfo",
        data: entityInfo.data
      });
      
      transformData(entityInfo.data);
    }
  };
let columns= []
let data = []
  const transformData = (apiData) => {
    if (!isEmpty(apiData) && Array.isArray(apiData)) {
      let newColumns = []
      let tempCol = apiData.map((dataItem, index) => {
        let year = dataItem.filter((item) => item.key === 'year')
        let yearValue = year[0].value
        const isProvisional = dataItem.some(item => item.key === 'isProvisional' && item.value === true);
        if (isProvisional) {
          yearValue = `${dateFormat(yearValue, "YYYY")} (Provisional)`;
        } else {
          yearValue = dateFormat(yearValue, "YYYY");
        }
        return yearValue;
      });

      newColumns = [...newColumns, {
        name: 'Particulars (Amount Lac.)',
        selector: 'title',
        key: 'title',
        sortable: true,
      }]
      let tempColumns = tempCol.map((item, index) => {
        return {
          name: item,
          selector: item,
          key: item,
          sortable: true,
        }
      })
      columns = [...newColumns, ...tempColumns]
      setColumns(columns)
    }

    let tempData = {}
    const key = "Financial Summary"
    const transformedData = {};

    apiData.forEach((row, index) => {
      row.forEach(item => {
        if (item.key === "isProvisional") return;
        if (item.key === "year") return;
        if (!transformedData[item.displayName]) {
          transformedData[item.displayName] = {};
        }
        transformedData[item.displayName][columns[index + 1]['key']] = item.value;
      });
    });

    const finalData = Object.keys(transformedData).map(title => ({
      title,
      ...transformedData[title],
    }));

    tempData = {
      key: key,
      data: finalData
    }

    data = [...data, tempData]
    setData(data)
  }  

  useEffect(() => {
    if (entityId) {
      loadData(entityId);
      fetchFinancialSummary(entityId);
    }
  }, [entityId]);
  
  // const handleDealSelection = (dealId) => {
  //   // Close the modal and navigate to entity profile with the selected deal
  //   setShowDealModal(false);
  //   navigateToentityProfile(dealId);
  // };
  const formatAmount = (amount) => {
    if (typeof amount === 'number' || (typeof amount === 'string' && !isNaN(amount))) {
        const numericAmount = Number(amount);
        return `₹ ${numericAmount.toLocaleString('en-IN')}`;
    }
    return amount;
  }
  const rowsToSkipFormatting = [
    'TOL/ TNW', 
    'EBITDA / Interest (times)', 
    'Current Ratio', 
    'Debt Equity Ratio', 
    'Debtors to sales (days)', 
    'Creditors to purchases (days)', 
    'Inventory stock (Days)', 
    'Cash Conversion (in days)',
    'EBITDA %',
    'PAT %'
];
const formatToTwoDecimal = (num) => {
  if (typeof num === 'number') {
    return num.toFixed(2);
  } else if (typeof num === 'string' && !isNaN(num)) {
    return parseFloat(num).toFixed(2);
  }
  return num; 
};
function capitalizeWords(str) {
  if (!str) return ""; 
  return str.toUpperCase(); 
}
useEffect(() => {
  // Automatically select the only deal if there's only one in the list
  if (dealList.length === 1) {
    setSelectedDealId(dealList[0].id);
    getOneDeal({ id: dealList[0].id })
      .then((response) => {
        if (response) {
          setDealDetails(response);
        }
      })
      .catch((error) => {
        console.error("Error fetching deal details:", error);
      });
  }
}, [dealList]);

  const handleUpdateFinancialSummary = async () => {
    const bodyData = {
      entityId: entityId
    };
    const response = await callGetFinancialsSummary(bodyData);
    setEntityData({
      key: "FInInfo",
      data: response.data
    });
    
  }
  useEffect(() => {
}, [entityData]);


  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <div className="vertical-scroll">
          {entityDetail.map((elem) => {
            return (
              <div key={uId()}>
                <h3
                  style={{ color: "#21aa47" }}
                  title={elem.entityName}
                  className="limited-text"
                >
                  {elem.entityName}
                </h3>
                <Col
                  sm={12}
                  className="constituition d-sm-flex justify-content-between"
                >
                  <div className="d-sm-flex align-items-center justify-content-between gap-3">
                  {elem.entityConstitution && (
                   <span className="d-flex align-items-center">
                   <i className="fas fa-building mx-1 text-success" id="constitution-icon"></i>
                    {elem.entityConstitution}
                    </span>
                    )}
                    {elem.pan &&(
                    <span className="d-flex align-items-center">
                    <i className="fas fa-id-card mx-1 text-success" id="pan-icon"></i>
                    {elem.pan}
                    </span>
                    )}
                  </div>
                  <div className="d-sm-flex justify-content-between">
                    <span
                      style={{
                        color: "#21aa47",
                        fontSize: "20px",
                        marginTop: "-30px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-alt mx-3"
                        id="schedule-meeting"
                        onClick={() => navigateToScheduleMeeting()}
                      ></i>
                      <i
                        className="fas fa-tasks  mx-3 "
                        id="add-task"
                        onClick={() => navigateToAddTask()}
                      ></i>
                      <i
                        className="fas fa-file-alt mx-3 "
                        id="add-note"
                        onClick={() => navigateToAddNotes()}
                      ></i>
                      {loading ? (
                        <i
                          className="fa fa-redo fa-spin"
                          style={{
                            fontSize: "24px",
                            cursor: "pointer",
                            marginTop: -7,
                          }}
                          id="new-icon"
                        ></i>
                      ) : (
                        <img
                          src={iconStatus ? financierIconGray : financierIcon}
                          className="mx-3"
                          style={{
                            cursor: "pointer",
                            marginTop: -7,
                          }}
                          alt="Action Icon"
                          id="new-icon"
                          onClick={async () => {
                            if (!loading) {
                              if (iconStatus) {
                                const response = await fetchFinancialSummary(
                                  entityId
                                );
                                const respondedAt = response?.respondedAt;
                                const date = dateFormat(
                                  respondedAt,
                                  "DD-MM-yyyy"
                                );
                                const message = `Data is already fetched on ${date}. Do you want to fetch again?`;
                                setShowCommonDialog({
                                  isShow: true,
                                  message: message,
                                  data: { type: "icon", entityId: entityId },
                                });
                              } else {
                                const message =
                                  "Are you sure you want to fetch data from Probe42? Please note that this action will incur a cost";
                                setShowCommonDialog({
                                  isShow: true,
                                  message: message,
                                  data: { type: "icon" },
                                });
                              }
                            }
                          }}
                        />
                      )}

                      {pushToTradeasyPayearlyPemission && (
                        <>
                          <button
                            type="button"
                            className="mx-2"
                            id="pushtotradeEasy"
                            style={buttonStyle(isTradeasyFlag)}
                            // onClick={() => {
                            //   if (!isTradeasyFlag) {
                            //     const message = 'Are you sure want to push this entity to tradeEasy?'
                            //     setShowCommonDialog({ isShow: true, message: message, data: { type: 'tradeEasy' } })
                            //   }
                            // }}
                            onClick={handleTradeEasyClick}
                          >
                            <img
                              src={
                                isTradeasyFlag ? disabledTradeIcon : tradeIcon
                              }
                              alt="Trade Easy"
                              style={{ height: "20px", width: "20px" }}
                            />
                          </button>
                          <button
                            type="button"
                            className="mx-2"
                            id="pushtoPayEarly"
                            style={buttonStyle(isPayEarlyFlag)}
                            onClick={handlePayearlyClick}
                          >
                            <img
                              src={
                                isPayEarlyFlag
                                  ? disabledPayearlyIcon
                                  : payearlyIcon
                              }
                              alt="payearly"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </button>

                          <UncontrolledTooltip
                            placement="top"
                            target="pushtotradeEasy"
                          >
                            {isTradeasyFlag
                              ? "Already pushed to TradeEasy"
                              : "Push to TradeEasy"}
                          </UncontrolledTooltip>
                          <UncontrolledTooltip
                            placement="top"
                            target="pushtoPayEarly"
                          >
                            {isPayEarlyFlag
                              ? "Already pushed to PayEarly"
                              : "Push to PayEarly"}
                          </UncontrolledTooltip>

                          {showCommonDialog && (
                            <CommonDialog
                              isShow={showCommonDialog.isShow}
                              message={showCommonDialog.message}
                              data={showCommonDialog.data}
                              postitiveBtn={"Submit"}
                              negativeBtn={"Close"}
                              onCloseFn={dialogAction}
                            ></CommonDialog>
                          )}
                          <Loader
                            show={loader}
                            type="box"
                            message="Pushing Entity to TradeEasy"
                          />
                          <Loader
                            show={loaderPayEarly}
                            type="box"
                            message="Pushing Entity to PayEarly"
                          />
                        </>
                      )}
                      {/* {dealList.length > 0 && (
                        <i
                        className="fas fa-solid fa-download mx-3 "
                        id="financials-details"
                        onClick={() => {
                          if (dealList.length > 0) {
                            setShowDealModal(true)
                          } 
                        }}
                      >
                        {(
                      <UncontrolledTooltip
                        placement="top"
                        target="financials-details"
                      >
                       Download CAM
                      </UncontrolledTooltip>
                    )}
                      </i>
                      
                      )} */}
                    </span>
                    <UncontrolledTooltip
                      placement="top"
                      target="schedule-meeting"
                    >
                      Schedule Meeting
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="add-task">
                      Add Task
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="add-note">
                      Add Note
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="new-icon">
                      Basic Financial Details
                    </UncontrolledTooltip>
                    {showCommonDialog && (
                      <CommonDialog
                        isShow={showCommonDialog.isShow}
                        message={showCommonDialog.message}
                        data={showCommonDialog.data}
                        postitiveBtn={"Submit"}
                        negativeBtn={"Close"}
                        onCloseFn={dialogAction}
                      ></CommonDialog>
                    )}
                    
                  </div>
                </Col>
                <Row>
                  <Col sm={3} md={6} lg={3} className="mb-2 max-content-mobile">
                    <div className="font-size-14 text-color-success3" style={{ fontWeight: '600' }}>RM</div>
                    <div className="dark-grey font-size-14">
                      {getDisplayName(entityDetail[0]?.programOwnerUser)}
                    </div>
                    <div className="grey font-size-14">
                      {entityDetail[0]?.programOwnerUser?.mobile_no || "-"}
                    </div>
                  </Col>
                  <Col sm={3} md={6} lg={3} className="mb-2 max-content-mobile">
                    <div className="font-size-14 text-color-success3" style={{ fontWeight: '600' }}>
                      Entity Contact
                    </div>
                    <div className="dark-grey font-size-14">
                      {getDisplayNamePOC(pocList) || ""}
                    </div>
                    <div className="grey font-size-14">
                      {pocList.contactNumber || "-"}
                    </div>
                  </Col>
                  <Col sm={3} md={6} lg={3} className="mb-2 max-content-mobile">
                    <div className="font-size-14 text-color-success3" style={{ fontWeight: '600' }}>
                      Entity Location
                    </div>
                    <div className="dark-grey font-size-14">
                      {entityDetail[0]?.addresses[0]?.city || ""}
                    </div>
                    <div className="grey font-size-14">
                      {entityDetail[0]?.addresses[0]?.state || "-"}
                    </div>
                  </Col>
                  <Col sm={3} md={6} lg={3} className="mb-2 max-content-mobile">
                    <div className="font-size-14 text-color-success3" style={{ fontWeight: '600' }}>
                      Entity Ratings
                    </div>
                    {entityDetail[0]?.creditRating ?(
                      <>
                        <div className="dark-grey font-size-14">
                        <span>
                        {entityDetail[0]?.creditRating.split("/")[0]?.trim()}
                        </span>
                        {" / "}
                        <span>
                        {entityDetail[0]?.creditRating.split("/")[1]?.trim()}
                        </span>
                        </div>
                      </>
                    ) : (
                      <div className="grey font-size-14">-</div>
                    )}
                  </Col>
                </Row>
              </div>
            );
          })}
          <svg
            className={`dashed-horizontal-div stroke-width-3 dash-length-20`}
            height={10}
          >
            <line
              x1="0"
              y1={20 / 2}
              x2="100%"
              y2={20 / 2}
              className="dash-line"
            />
          </svg>
          <Nav tabs className="nav-tabs-custom nav-justified mb-4">
            <NavItem>
              <NavLink
                style={{
                  cursor: "pointer",
                }}
                className={classnames({
                  active: customActiveTab === "1",
                  "nested-tab-active": customActiveTab === "1",
                })}
                onClick={() => {
                  toggleCustom("1");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="bx bxs-factory"></i>
                </span>
                <span className="d-none d-sm-block">Entity Profile</span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "2",
                  "nested-tab-active": customActiveTab === "2",
                })}
                onClick={() => {
                  toggleCustom("2");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="bx bx-rupee"></i>
                </span>
                <span className="d-none d-sm-block">
                  Deals({dealList.length})
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "7",
                  "nested-tab-active": customActiveTab === "7",
                })}
                onClick={() => {
                  toggleCustom("7");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-user-tie"></i>
                </span>
                <span className="d-none d-sm-block">Financials</span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "3",
                  "nested-tab-active": customActiveTab === "3",
                })}
                onClick={() => {
                  toggleCustom("3");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="bx bxs-file-doc"></i>
                </span>
                <span className="d-none d-sm-block">APIs</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "8",
                  "nested-tab-active": customActiveTab === "8",
                })}
                onClick={() => {
                  toggleCustom("8");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="bx bxs-file-doc"></i>
                </span>
                <span className="d-none d-sm-block">Documents</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "9",
                  "nested-tab-active": customActiveTab === "9",
                })}
                onClick={() => {
                  toggleCustom("9");
                  fetchMeetings(entityId);
                  fetchNotes(entityId);
                  fetchTasks(entityId);
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="bx bxs-file-doc"></i>
                </span>
                <span className="d-none d-sm-block">Activities</span>
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "4",
                  "nested-tab-active": customActiveTab === "4",
                })}
                onClick={() => {
                  toggleCustom("4");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-calendar"></i>
                </span>
                <span className="d-none d-sm-block">
                  Meetings({totalMeeting.length})
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "5",
                  "nested-tab-active": customActiveTab === "5",
                })}
                onClick={() => {
                  toggleCustom("5");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-file"></i>
                </span>
                <span className="d-none d-sm-block">
                  Notes({totalNotes.length})
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "6",
                  "nested-tab-active": customActiveTab === "6",
                })}
                onClick={() => {
                  toggleCustom("6");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-tasks"></i>
                </span>
                <span className="d-none d-sm-block">
                  Tasks({totalTask.length})
                </span>
              </NavLink>
            </NavItem> */}
          </Nav>

          <TabContent activeTab={customActiveTab} className="p-3 text-muted">
            <TabPane tabId="1">
              {constituition === "Proprietorship" ? (
                <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                  <NavItem>
                    <NavLink
                      style={{
                        cursor: "pointer",
                      }}
                      className={classnames({
                        active: entityProfileTab === "7",
                        "custom-active-tab": entityProfileTab === "7",
                      })}
                      onClick={() => {
                        toggleEntityProfile("7");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-user-detail"></i>
                      </span>
                      <span className="d-none d-sm-block">Entity Detail</span>
                    </NavLink>
                  </NavItem>

                  {constituition == "Proprietorship" ? (
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: entityProfileTab === "12",
                          "custom-active-tab": entityProfileTab === "12",
                        })}
                        onClick={() => {
                          toggleEntityProfile("12");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="bx bxs-user"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Proprietor Details
                        </span>
                      </NavLink>
                    </NavItem>
                  ) : null}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: entityProfileTab === "11",
                        "custom-active-tab": entityProfileTab === "11",
                      })}
                      onClick={() => {
                        toggleEntityProfile("11");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-bank"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Borrowing Profile
                      </span>
                    </NavLink>
                  </NavItem>

                  {constituition == "Public Limited Company" ||
                  constituition == "Private Limited Company" ||
                  constituition == "Limited Liability Partnership" ||
                  constituition == "Partnership" ? (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: entityProfileTab === "10",
                          "custom-active-tab": entityProfileTab === "10",
                        })}
                        onClick={() => {
                          toggleEntityProfile("10");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="bx bxs-bar-chart-alt-2"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Shareholding Pattern
                        </span>
                      </NavLink>
                    </NavItem>
                  ) : null}
                </Nav>
              ) : (
                <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                  <NavItem>
                    <NavLink
                      style={{
                        cursor: "pointer",
                      }}
                      className={classnames({
                        active: entityProfileTab === "7",
                        "custom-active-tab": entityProfileTab === "7",
                      })}
                      onClick={() => {
                        toggleEntityProfile("7");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-user-detail"></i>
                      </span>
                      <span className="d-none d-sm-block">Entity Details</span>
                    </NavLink>
                  </NavItem>

                  {constituition == "Public Limited Company" ||
                  constituition == "Private Limited Company" ? (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: entityProfileTab === "9",
                          "custom-active-tab": entityProfileTab === "9",
                        })}
                        onClick={() => {
                          toggleEntityProfile("9");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="bx bxs-group"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Directors and Promoters
                        </span>
                      </NavLink>
                    </NavItem>
                  ) : null}

                  {constituition == "Limited Liability Partnership" ||
                  constituition == "Partnership" ? (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: entityProfileTab === "8",
                          "custom-active-tab": entityProfileTab === "8",
                        })}
                        onClick={() => {
                          toggleEntityProfile("8");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="bx bxs-group"></i>
                        </span>
                        <span className="d-none d-sm-block">Partners</span>
                      </NavLink>
                    </NavItem>
                  ) : null}

                  {constituition == "Public Limited Company" ||
                  constituition == "Private Limited Company" ||
                  constituition == "Limited Liability Partnership" ||
                  constituition == "Partnership" ? (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: entityProfileTab === "10",
                          "custom-active-tab": entityProfileTab === "10",
                        })}
                        onClick={() => {
                          toggleEntityProfile("10");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="bx bxs-bar-chart-alt-2"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Shareholding Pattern
                        </span>
                      </NavLink>
                    </NavItem>
                  ) : null}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: entityProfileTab === "11",
                        "custom-active-tab": entityProfileTab === "11",
                      })}
                      onClick={() => {
                        toggleEntityProfile("11");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-bank"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Borrowing Profile
                      </span>
                    </NavLink>
                  </NavItem>
                  {constituition == "Proprietorship" ? (
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: entityProfileTab === "12",
                          "custom-active-tab": entityProfileTab === "12",
                        })}
                        onClick={() => {
                          toggleEntityProfile("12");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="bx bxs-user"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Proprietor Details
                        </span>
                      </NavLink>
                    </NavItem>
                  ) : null}
                </Nav>
              )}
            </TabPane>
            {customActiveTab == "1" && (
              <div className="horizontalDivNestedTab"></div>
            )}

            <TabPane tabId="2">
              <Row>
                <Col lg={12}>
                  {isNewDealPermission && isPanExists ? (
                    <div className="d-flex justify-content-end">
                      <Button
                        type="button"
                        style={{
                          backgroundColor: "#21aa47",
                          borderColor: "#21aa47",
                          color: "#fff",
                        }}
                        className="mb-3 me-2"
                        onClick={() => navigateToAddDeal()}
                      >
                        <i className="fas fa-plus me-2"></i>
                        <span> Create Deal</span>
                      </Button>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row className="entityRow">
                {!isPanExists ? (
                  <div className="alert alert-danger text-center">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    This entity doesn't have a PAN number, hence a deal cannot
                    be created. Please add a PAN number for the entity first.
                  </div>
                ) : (
                  <>
                    {dealList.map((elem, index) => (
                      <Col sm={12} md={6} lg={4} key={uId()}>
                        <Card style={{ borderRadius: "10px" }}>
                          <CardBody
                            className="card-hover card-style vertical-scroll"
                            style={{ padding: "14px", height: "210px" }}
                          >
                            <div className="mb-1 d-flex justify-content-between align-items-center">
                              <div
                                className="text-color-dark"
                                title={elem.dealName}
                              >
                                {truncateText(elem.dealName, 24)}
                              </div>
                              <div className="ms-2 d-flex">
                                {/* {elem.dealProductCommercials[0]?.productType === "Working Capital" &&( */}
                                   {/* <i
                                   className="mdi mdi-table font-size-16 text-success me-2"
                                   id="viewdealtooltip-view"
                                   onClick={() => navigateToentityProfile(elem.id)}
                                   title="CAM in Editor"
                                 ></i> */}
                                {/* // )} */}
                                {isCamGeneration && (
                                    <i
                                    className="mdi mdi-book-plus font-size-16 text-success me-2"
                                    id="viewdealtooltip-view"
                                    onClick={() => navigateToCamGenerate(elem.id)}
                                    title="Generate CAM"
                                  ></i>
                                 )}
                                <i
                                  className="mdi mdi-eye font-size-16 text-success me-2"
                                  id="viewdealtooltip-view"
                                  onClick={() => navigateToViewDeal(elem.id)}
                                  title="View"
                                ></i>
                                
                                {entityDetails.roleName !==
                                "fundLync_cutomer" ? (
                                  elem.status != 15 &&
                                  elem.status != 11 &&
                                  elem.status != 12 ? (
                                    <i
                                      className="mdi mdi-pencil font-size-16 text-success"
                                      id="editdealtooltip-edit"
                                      onClick={() =>
                                        navigateToEditDeal(elem.id)
                                      }
                                      title="Edit"
                                    ></i>
                                  ) : (
                                    <>
                                      <i
                                        className="mdi mdi-pencil font-size-16 text-muted"
                                        id="editdealtooltip-edit-disabled"
                                        style={{
                                          opacity: 0.5,
                                          cursor: "not-allowed",
                                        }}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="editdealtooltip-edit-disabled"
                                      >
                                        Editing is not available for Live,
                                        Approved, or Rejected deals
                                      </UncontrolledTooltip>
                                    </>
                                  )
                                ) : elem.status == 3 ? (
                                  <i
                                    className="mdi mdi-pencil font-size-16 text-success"
                                    id="editdealtooltip-edit"
                                    onClick={() => navigateToEditDeal(elem.id)}
                                    title="Edit"
                                  ></i>
                                ) : (
                                  <>
                                    <i
                                      className="mdi mdi-pencil font-size-16 text-muted"
                                      id="editdealtooltip-edit-disabled"
                                      style={{
                                        opacity: 0.5,
                                        cursor: "not-allowed",
                                      }}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target="editdealtooltip-edit-disabled"
                                    >
                                      Editing is only available for Draft Deals
                                    </UncontrolledTooltip>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="font-size-11 text-color-success date-text d-flex justify-content-between gap-1">
                              <div className="text-color-success font-size-14">
                                ₹{" "}
                                {formatNumberWithCommas(+elem.loanRequirement)}
                              </div>
                              <div className="font-size-14">
                                <i className="bx bx-calendar-event"></i>
                                {dateFormat(elem.createdAt, "DD-MM-YYYY")}
                              </div>
                            </div>

                            <div className="mb-1">
                              <div className="grey3">
                                {productNameArray(elem.product)?.map(
                                  (ele, index) => (
                                    <Button
                                      key={index}
                                      type="button"
                                      color={"secondary"}
                                      className="btn-rounded me-2 mt-2 font-size-12"
                                      style={{ padding: "4px 10px 4px 10px" }}
                                      title={ele}
                                      outline
                                    >
                                      {truncateText(ele, 15)}
                                    </Button>
                                  )
                                )}
                              </div>
                            </div>

                            <div className="d-flex justify-content-between mb-1 align-items-center">
                              <div className="d-flex align-items-center">
                                <div className="text-color-success2 me-1">
                                  RM :
                                </div>
                                <div className="grey2">
                                  {getDisplayName(elem?.assignedToUser) || "-"}
                                </div>
                              </div>
                              {elem?.rateOfInterest !== 0 &&
                                elem?.rateOfInterest && (
                                  <div className="d-flex">
                                    <div className="text-color-success2 me-1">
                                      ROI :
                                    </div>
                                    <div className="grey2">
                                      {elem?.rateOfInterest
                                        ? elem?.rateOfInterest + "%"
                                        : "-"}
                                    </div>
                                  </div>
                                )}
                            </div>

                            <div className="d-flex justify-content-between mb-1">
                              <div className="d-flex">
                                <div className="text-color-success2 me-1">
                                  FI Status :
                                </div>
                                <div
                                  className="grey2"
                                  title={`Interested financiers : ${elem?.financierCount}, Accepted financiers : ${elem?.acceptCount}, Rejected financiers : ${elem?.rejectCount} ,Referred financiers :${elem?.financier?.length ?? 0},Preferred financiers :${elem?.preferredFinancier?.length ?? 0}`}
                                >
                                <span className="primary-color">I</span>:{" "}
                                {elem?.financierCount} /{" "}
                                <span className="text-color-success">A</span>:{" "}
                                {elem?.acceptCount} /{" "}
                                <span className="danger-color">R</span>:{" "}
                                {elem?.rejectCount}/{" "}
                                  <span style={{color:'#008b8b'}} >RF</span>:{" "}
                                  {elem?.financier?.length ? elem.financier.length : 0}
                                  /{" "}
                                  <span style={{color:'#7C4DFF'}} >PF</span>:{" "}
                                  {(elem?.preferredFinancier && elem.preferredFinancier.length) || 0}
                                </div>
                              </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                {elem.status == 4 ||
                                elem.status == 1 ||
                                elem.status == 5 ||
                                elem.status == 2 ||
                                elem.status == 3 ? (
                                  <Button
                                    type="button"
                                    color={
                                      elem.status != 5 && elem.status != 3
                                        ? "success"
                                        : "warning"
                                    }
                                    className="btn-rounded me-2 mt-2"
                                    style={{ padding: "4px 10px 4px 10px" }}
                                    outline
                                  >
                                    {elem.statusName}
                                  </Button>
                                ) : (
                                  <Button
                                    type="button"
                                    color="primary"
                                    className="btn-rounded me-2 mt-2 font-size-12"
                                    style={{ padding: "4px 10px 4px 10px" }}
                                    outline
                                  >
                                    {elem.statusName}
                                  </Button>
                                )}
                              </div>

                              {/* <div className="arrow-color">
                                <i className="fas fa-arrow-right"></i>
                              </div> */}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                    {dealList.length === 0 && (
                      <div className="text-center font-size-20 fw-medium">
                        No Deals Found
                      </div>
                    )}
                  </>
                )}
              </Row>
            </TabPane>

            <TabPane tabId="3">
              <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                {constituition == "Proprietorship" ||
                constituition == "Limited Liability Partnership" || constituition == "Public Limited Company" ||
                constituition == "Private Limited Company" ||
                constituition == "Partnership" ? (
                  <NavItem>
                    <NavLink
                      style={{
                        cursor: "pointer",
                      }}
                      className={classnames({
                        active: documentTab === "13",
                        "custom-active-tab": documentTab === "13",
                      })}
                      onClick={() => {
                        toggleDocumentTab("13");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-dock-top"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Credit Verification
                      </span>
                    </NavLink>
                  </NavItem>
                ) : null}
                {constituition == "Proprietorship" ||
                constituition == "Limited Liability Partnership" || constituition == "Public Limited Company" ||
                constituition == "Private Limited Company" ||
                constituition == "Partnership" ? (
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: documentTab === "14",
                        "custom-active-tab": documentTab === "14",
                      })}
                      onClick={() => {
                        toggleDocumentTab("14");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-dock-top"></i>
                      </span>
                      <span className="d-none d-sm-block">ITR Documents</span>
                    </NavLink>
                  </NavItem>
                ) : null}
                {constituition == "Proprietorship" ||
                constituition == "Limited Liability Partnership" || constituition == "Public Limited Company" ||
                constituition == "Private Limited Company" ||
                constituition == "Partnership" ? (
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: documentTab === "15",
                        "custom-active-tab": documentTab === "15",
                      })}
                      onClick={() => {
                        toggleDocumentTab("15");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-dock-top"></i>
                      </span>
                      <span className="d-none d-sm-block">GST Documents</span>
                    </NavLink>
                  </NavItem>
                ) : null}
                {constituition == "Proprietorship" ||
                constituition == "Limited Liability Partnership" || constituition == "Public Limited Company" ||
                constituition == "Private Limited Company" ||
                constituition == "Partnership" ? (
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: documentTab === "16",
                        "custom-active-tab": documentTab === "16",
                      })}
                      onClick={() => {
                        toggleDocumentTab("16");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-dock-top"></i>
                      </span>
                      <span className="d-none d-sm-block">Bank Statements</span>
                    </NavLink>
                  </NavItem>
                ) : null}
                {constituition == "Public Limited Company" ||
                constituition == "Private Limited Company" ? (
                  <NavItem>
                    <NavLink
                      style={{
                        cursor: "pointer",
                      }}
                      className={classnames({
                        active: documentTab === "17",
                        "custom-active-tab": documentTab === "17",
                      })}
                      onClick={() => {
                        toggleDocumentTab("17");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-dock-top"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Audited Financials
                      </span>
                    </NavLink>
                  </NavItem>
                ) : (
                  <NavItem>
                    <NavLink
                      style={{
                        cursor: "pointer",
                      }}
                      className={classnames({
                        active: documentTab === "17",
                        "custom-active-tab": documentTab === "17",
                      })}
                      onClick={() => {
                        toggleDocumentTab("17");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="bx bxs-dock-top"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Audited Financials
                      </span>
                    </NavLink>
                  </NavItem>
                )}
               
              </Nav>
            </TabPane>
            {customActiveTab == "3" && (
              <div className="horizontalDivNestedTab"></div>
            )}

            {/* <TabPane tabId="4">
              
            </TabPane> */}

            <TabPane tabId="9">
            <Row lg="12">
            <div>
           <Card style={{ padding: "10px" }}>
          <div
          className="d-flex justify-content-between mt-1"
          style={{ cursor: "pointer" }}
          onClick={() => toggleDropdownNew(0)}
        >
          <div>
            <h5 className="text-dark">Notes</h5>
          </div>
          <div className="me-2">
            <i
              className={`fas fa-angle-${isDropdownOpenNew[0] ? "up" : "down"}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>

        {isDropdownOpenNew[0] && (
          <Row>
            <Col xs="12" className="mt-1 mb-2 vertical-scroll">
            {isNotesTableVisible && (
                <EntityNotesTable
                  onCreateNewNote={handleCreateNewNoteButton}
                  onEditNote={handleEditNote}
                />
              )}
              {isNotesFormVisible && (
                <AddEntityNotes
                  onSchedule={handleCreateNewNote}
                  onCancel={handleCancelNote}
                />
              )}

              {isEditNotesVisible && (
                <EditEntityNote
                  editNoteId={editNoteId}
                  onUpdate={handleUpdateNoteButton}
                  onCancel={handleCancelNoteButton}
                />
              )}
            </Col>
          </Row>
        )}
      </Card>
    </div>
    <div>
      <Card style={{ padding: "10px" }}>
        <div
          className="d-flex justify-content-between mt-1"
          style={{ cursor: "pointer" }}
          onClick={() => toggleDropdownNew(1)}
        >
          <div>
            <h5 className="text-dark">Meetings</h5>
          </div>
          <div className="me-2">
            <i
              className={`fas fa-angle-${isDropdownOpenNew[1] ? "up" : "down"}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>

        {isDropdownOpenNew[1] && (
          <Row>
            <Col xs="12" className="mt-1 mb-2 vertical-scroll">
            {isTableVisible && (
                <EntityMeetingTable
                  onCreateNewMeeting={handleCreateNewMeeting}
                  onEditMeeting={handleEditMeeting}
                  onViewMeeting={handleviewMeeting}
                />
              )}
              {isFormVisible && (
                <ScheduleMeetngForm
                  onSchedule={handleScheduleMeeting}
                  onCancel={handleCancelMeeting}
                />
              )}

              {isEditFormVisible && (
                <UpdateEntityMeetings
                  editMeetingId={editMeetingId}
                  onUpdate={handleUpdateMeetingButton}
                  onCancel={handleCancelMeetingButton}
                />
              )}

              {isViewFormVisible && (
                <ViewEntityMeetingDetails
                  viewMeetingId={viewMeetingId}
                  onCancel={handleCancelViewButton}
                />
              )}
            </Col>
          </Row>
        )}
      </Card>
    </div>
    <div>
      <Card style={{ padding: "10px" }}>
        <div
          className="d-flex justify-content-between mt-1"
          style={{ cursor: "pointer" }}
          onClick={() => toggleDropdownNew(2)}
        >
          <div>
            <h5 className="text-dark">Tasks</h5>
          </div>
          <div className="me-2">
            <i
              className={`fas fa-angle-${isDropdownOpenNew[2] ? "up" : "down"}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>

        {isDropdownOpenNew[2] && (
          <Row>
            <Col xs="12" className="mt-1 mb-2 vertical-scroll">
            {isTaskTableVisible && (
                <EntityTaskTable
                  onCreateNewtask={handleCreateNewTaskButton}
                  onEditTask={handleEditTask}
                  onViewTask={handleviewTask}
                />
              )}
              {isTaskFormVisible && (
                <AddTaskForm
                  onSchedule={handleCreateNewtask}
                  onCancel={handleCancelTask}
                />
              )}

              {isEditTaskVisible && (
                <UpdateEntityTask
                  editTaskId={editTaskId}
                  onUpdate={handleUpdateTaskButton}
                  onCancel={handleCancelTaskButton}
                />
              )}

              {isViewTaskVisible && (
                <ViewEntityTaskDetails
                  viewTaskId={viewTaskId}
                  onViewTask={handleviewMeeting}
                  onCancel={handleCancelTaskViewButton}
                />
              )}
            </Col>
            </Row>
             )}
            </Card>
            </div>
             </Row>   
            </TabPane>

            <TabPane tabId="6">
             
            </TabPane>
            <TabPane tabId="7">
              <Row lg="12">
                <Provisional entityId={entityId} responseId={responseId} onUpdate={getEntityData}/>
                <div>
                  <Card style={{ padding: "10px" }}>
                    <div
                      className="d-flex justify-content-between mt-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleDropdown(0)}
                    >
                      <div>
                        <h5 style={{ color: "#42B763" }}>Financials Summary</h5>
                      </div>
                      <div className="me-2">
                        <i
                          className={`fas fa-angle-${
                            isDropdownOpen[0] ? "up" : "down"
                          }`}
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                    </div>

                    {isDropdownOpen[0] && (
                      <Row>
                        <Col xs="12" className="mb-2">
                          <Container fluid>
                        
                            <div>
                              
                              <Card style={{border:"none"}}>
                                <CardBody className="px-0">
                                <EntityDataTable data={data1} columns={columns1} />
                                </CardBody>
                              </Card>
                            </div>
                          </Container>
                        </Col>
                      </Row>
                    )}
                  </Card>
                </div>

                {/* Second Accordion */}
                <div>
                  <Card style={{ padding: "10px" }}>
                    <div
                      className="d-flex justify-content-between mt-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleDropdown(1)}
                    >
                      <div>
                        <h5 style={{ color: "#42B763" }}>Financials Details</h5>
                        
                      </div>
                      <div className="me-2">
                        <i
                          className={`fas fa-angle-${
                            isDropdownOpen[1] ? "up" : "down"
                          }`}
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                    </div>

                    {isDropdownOpen[1] && (
                      <Row>
                        <Col xs="12" className="mt-1 mb-2">
                          {/* Accordion 2 content will be here */}
                          <EntityMoreInformation />
                        </Col>
                      </Row>
                    )}
                  </Card>
                </div>

                {/* Third Accordion */}
                <div>
                  <Card style={{ padding: "10px" }}>
                    <div
                      className="d-flex justify-content-between mt-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleDropdown(2)}
                    >
                      <div>
                        <h5 style={{ color: "#42B763" }}>
                          Financials Analytics
                        </h5>
                      </div>
                      <div className="me-2">
                        <i
                          className={`fas fa-angle-${
                            isDropdownOpen[2] ? "up" : "down"
                          }`}
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                    </div>

                    {isDropdownOpen[2] && (
                      <Row>
                        <Col xs="12" className="mt-1 mb-2">
                          {/* Accordion 3 content will be here */}
                          <EntityInformation />
                        </Col>
                      </Row>
                    )}
                  </Card>
                </div>
              </Row>
            </TabPane>
            <TabPane tabId="8">
                {customActiveTab === "8" && (
                  <div className="p-3 text-muted">
                    <h5 className="mb-4">Additional Documents</h5>
                    <AdditionalDocuments />
                  </div>
                )}
            </TabPane>
          </TabContent>

          {entityProfileTab && customActiveTab === "1" && (
            <TabContent activeTab={entityProfileTab} className="p-3 text-muted">
              <TabPane tabId="7">
                <UpdateEntity />
              </TabPane>
              <TabPane tabId="8">
                {entityProfileTab==="8" && <Partners />}
              </TabPane>
              <TabPane tabId="9">
              {entityProfileTab==="9" && <Directors />}
              </TabPane>
              <TabPane tabId="10">
              {entityProfileTab==="10" && <ShareholdingPatterns />}
              </TabPane>
              <TabPane tabId="11">
              {entityProfileTab==="11" && <BorrowingProfile />}
              </TabPane>
              <TabPane tabId="12">
              {entityProfileTab==="12" && <Proprietors />}
              </TabPane>
            </TabContent>
          )}
          {documentTab && customActiveTab === "3" && (
            <TabContent activeTab={documentTab} className="p-3 text-muted">
              <TabPane tabId="13">
             <CreditVerification  customActiveTab={customActiveTab}/>
              </TabPane>
              <TabPane tabId="14">
              {documentTab==="14" && <ITRDocuments />}
              </TabPane>
              <TabPane tabId="15">
              {documentTab==="15" && <GSTDocuments />}
              </TabPane>
              <TabPane tabId="16">
              {documentTab==="16" &&   <BSADocuments />}
              </TabPane>
              <TabPane tabId="17">
              {documentTab==="17" &&    <FinancialDocuments />}
              </TabPane>
              {/* <TabPane tabId="8">
                <AdditionalDocuments />
              </TabPane> */}
            </TabContent>
          )}
        </div>
      </Container>
      
      
    </div>
    {showDealModal && dealList.length > 0 && (
      <Modal
        isOpen={showDealModal}
        role="dialog"
        autoFocus={true}
        centered
        toggle={() => setShowDealModal(!showDealModal)}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => setShowDealModal(false)}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select a Deal</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (!selectedDealId) {
                      // Set error message if no deal is selected
                      setErrorMessage('Please select a deal');
                      return; // Prevent form submission
                    }
                    navigateToentityProfile(selectedDealId);
                  }}
                >
                  <Col xl={12} className="mb-3">
                    <Label className="form-label text-start d-block">Select Deal</Label>
                    <Input
                      name="selectedDeal"
                      type="select"
                      onChange={handleDealSelection}
                      value={selectedDealId}
                      invalid={!!errorMessage}
                    >
                      <option value="" disabled>Select a Deal</option>
                      {dealList.map((deal) => (
                        <option key={deal.id} value={deal.id}>
                          {deal.dealName}
                        </option>
                      ))}
                    </Input>
                    {errorMessage && (
                  <div className="text-danger mt-1">{errorMessage}</div>
                )}
                    
                  </Col>
                  <Row>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end">
                        <Button
                          type="submit"
                          color="success"
                          className="mt-2"
                          onClick={() => setPDF(true)} 
                        >
                          Proceed
                        </Button>

                         {/* <Button
                          type="submit"
                          color="success"
                          className="mt-2"
                          onClick={() => setPDF(false)} 
                        >
                          Download Word
                        </Button> */}
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )}
    <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>    
  );
};

export default EntityDashboard;
